export function formatElapsed(ms) {
  const totalSec = Math.max(0, Math.floor((Number(ms) || 0) / 1000));
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function discoveryPercent({ probed = 0, total = 0 } = {}) {
  const done = Number(probed) || 0;
  const all = Number(total) || 0;
  if (all <= 0) return 0;
  return Math.min(100, Math.round((done / all) * 100));
}

export function readDiscoveryException(err) {
  const body = err?.response?.data;
  if (body && typeof body === 'object' && !(typeof Blob !== 'undefined' && body instanceof Blob)) {
    return {
      message: String(body.message || err.message || 'Discovery failed'),
      code: body.code || (err.response?.status === 503 ? 'SSH_KEY' : 'DISCOVERY_FAILED'),
      sshUser: body.sshUser || null,
      keyPath: body.keyPath || null,
      progress: body.progress || null,
    };
  }
  return {
    message: err?.message || 'Discovery failed',
    code: 'DISCOVERY_FAILED',
    sshUser: null,
    keyPath: null,
    progress: null,
  };
}
